<template>
  <svg
    :viewBox="icons[this.iconName].viewBox"
    preserveAspectRatio="xMidYMid meet"
    focusable="false"
    style="pointer-events: none; display: block;"
    class="icon"
  >
    <g :id="iconName" v-bind="gAttributes" v-html="innerSvg" />
  </svg>
</template>

<script>

import iconset from './icons'

export default {
  name: 'ns-icon',
  props: {
    iconName: {
      type: String,
      required: true,
      default: ''
    }
  },
  data () {
    return {
      icons: iconset
    }
  },
  computed: {
    gAttributes () {
      let attrs = []
      this.icons[this.iconName].g.forEach(attr => {
        let key = Object.keys(attr)[0]
        attrs.push({ [`${key}`]: attr[key] })
      })

      return attrs
    },
    innerSvg () {
      let parts = ''
      this.icons[this.iconName].parts.forEach(part => {
        parts += part
      })
      return parts
    }
  },
  mounted () {},
  methods: {
    returnIconSet () {
      return iconset
    }
  }
}
</script>

<style lang="scss" scoped>
  svg {
    fill: currentColor;
    stroke: currentColor;
  }
</style>
